import { ConfigService } from '../../'

/*& Models/Configs/History
	# HistoryConfig
*/
export class HistoryConfig {
	public color = '#F4F4F4'

	constructor(private config: ConfigService) {}

	update(config: any): HistoryConfig {
		if (typeof config.history === 'object') {
			this.color = this.config.getColor(config.history.color, this.color)
		}

		return this
	}
}



// WEBPACK FOOTER //
// ./src/app/electraLib/model/config/historyConfig.ts